<template>
    <div class="common-space-between">
        <div class="btn" v-for="(item,index) in btnList" :key="index"> 
            <el-button v-if="mark== item.mark" size="mini"  @click="tabBtn(item)">{{item.title}}</el-button>
            <el-button v-else  type="primary" size="mini"   @click="tabBtn(item)">{{item.title}}</el-button>
        </div> 
    </div>
</template>
<script>
  import { url,operate } from '@/utils/config'
  import { postFun } from '@/utils/httpFun'
  export default{
     data:()=>({
        mark:"",     
        btnList:[
            {title:"运维平台", mark:"operate"},
            {title:"用户平台", mark:"user"},
            {title:"IOT平台", mark:"iot"},
            // {title:"工厂平台",mark:"factory"},
            // {title:"代理商平台",mark:"agent"},
        ]
     }),
     created(){
        
         if(!localStorage.getItem("menuBtnVav")){
            this.getLIst(this.btnList[0].mark)
         }else{
            let parms = JSON.parse(localStorage.getItem("menuBtnVav"))
            this.mark = parms.mark
         }
     },
     methods:{

        //平台切换
        tabBtn(ev){
            //禁止重复点击
            if(ev.mark!=this.mark){
                this.getLIst(ev.mark)
            }
        },

        //获取左侧的数据 
        async getLIst(mark){
            await postFun(operate.LEFTNAV+"?systemCode="+mark,{},res=>{
              //表示没有权限 
              if(res.exceptionCode=="20008"){
                 return
              }
              this.mark = mark  
              let nabList = res.data
              let navBtn = [] 
              let parms = {}
              // 判断第一菜单下面是否有子菜单   
              if(!nabList[0].webUrl){
                  navBtn = [{menuID:nabList[0].id,menuSonID:nabList[0].childMBs[0].id,title:nabList[0].childMBs[0].name,url:nabList[0].childMBs[0].webUrl}]
                  parms = {
                        menuList:nabList,                   //切换的菜单
                        menuID: nabList[0].id,              //菜单主模块标志
                        menuSonID:nabList[0].childMBs[0].id,//菜单子模块标志
                        listMenuList:navBtn,                //首次进入选中的 
                        mark:mark                           //选中的平台
                  }
                  this.$router.replace({
                    path:nabList[0].childMBs[0].webUrl,
                    query:{}
                  }) 

              }else{
                  navBtn = [{menuID:nabList[0].id,menuSonID:nabList[0].id,title:nabList[0].name,url:nabList[0].webUrl}]
                  parms = {
                        menuList:nabList,                   //切换的菜单
                        menuID: nabList[0].id,              //菜单主模块标志
                        menuSonID:nabList[0].id,            //菜单子模块标志
                        listMenuList:navBtn,                //首次进入选中的 
                        mark:mark                           //选中的平台
                  }
                  this.$router.replace({
                    path:nabList[0].webUrl,
                    query:{}
                  }) 
              }
              localStorage.setItem("menuBtnVav",JSON.stringify(parms));
            })  
        }
     }
  }
</script>
<style lang="scss" scoped>
  .btn{
    margin-right: 10px!important;
    ::v-deep .el-button--primary{
        background: rgba(255,255,255,0.30);
        box-shadow: 2px 2px 8px 0px rgba(40,102,198,0.32);
        border-color: rgba(255,255,255,0);
        font-size: 12px;
        color: #FFFFFF;
        letter-spacing: 0;
        font-weight: 400;
        border-radius: 6px;
        height: 32px;
        margin-right: 5px;
    }
    ::v-deep .el-button--default{
        background: #FFFFFF;
        font-size: 12px;
        height: 32px;
        color: #3D465F;
        border-radius: 6px;
        box-shadow: 2px 2px 8px 0px rgba(40,102,198,0.32);
        margin-right: 5px;
    }
  }
</style>